interface RememberMeProps {
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}

export function RememberMe({ checked, disabled, onChange }: RememberMeProps) {
  return (
    <label
      className="flex cursor-pointer items-center gap-2 text-sm text-[var(--muted-foreground)]"
      htmlFor="remember-me"
    >
      <input
        checked={checked}
        className="size-4 shrink-0 accent-[var(--action)]"
        disabled={disabled}
        id="remember-me"
        name="remember-me"
        type="checkbox"
        onChange={(event) => onChange(event.target.checked)}
      />
      Remember me
    </label>
  );
}
